var Video = function () {
	var video,
		videoUrl,
		YTiframe;
	var player;
	var comp = $('[data-component="video"]');

	function init() {

		comp.each(function () {
			var comp = $(this);

			if(comp.hasClass('youtube')) {

				comp.find('.play').on('click', function () {
					YTiframe = comp.find('.youtube-iframe');
					video = YTiframe.attr('id');
					videoUrl = YTiframe.data('video');
					onYouTubeIframeAPIReady(video, videoUrl);
				});

			} else {

				comp.find('.play').on('click', function () {

					comp.find('video').addClass('appear');

					setTimeout(function() {
						var v = comp.find('video')[0];
						v.play();
					}, 100);

				});
			}

		});

	}

	function onYouTubeIframeAPIReady(video, url) {
		setTimeout(function () {
			player = new YT.Player(video, {
				videoId: url,
				events: {
					'onReady': onPlayerReady,
				}
			});
		}, 1);
	}

	function onPlayerReady(event) {
		event.target.playVideo();
	}

	return init();
}
